import { render } from "./Scoreboard.vue?vue&type=template&id=59f87718&scoped=true"
import script from "./Scoreboard.vue?vue&type=script&lang=js"
export * from "./Scoreboard.vue?vue&type=script&lang=js"

import "./Scoreboard.vue?vue&type=style&index=0&id=59f87718&scoped=true&lang=css"

import exportComponent from "/github/workspace/timmies-helper-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f87718"]])

export default __exports__